import { Node, mergeAttributes } from "@tiptap/core";

const TiptapInlineSection = Node.create({
  name: "inlineSection",

  priority: 1000,

  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },

  group: "block",

  content: "inline*",

  parseHTML() {
    return [{ tag: "section" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "section",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: "tip-inline-section"
      }),
      0
    ];
  },

  addCommands() {
    return {
      setInlineSection: () => ({ commands }) => {
        return commands.setNode("inlineSection");
      }
    };
  }
});

export default TiptapInlineSection;
